<template>
  <div>
    <!-- <v-form>
      <v-container>
        <v-row>
          <v-col cols="3">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-col>
          <v-col>
            <v-layout justify-end>
              <v-btn rounded @click="loadReports">Refresh</v-btn>
            </v-layout>
          </v-col>
        </v-row>
      </v-container>
    </v-form> -->
    <v-card>
      <v-card-title color="secondary">Ignite - 360º Insights
        <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
        <v-btn light text @click="loadReports" color="secondary">
          <v-icon>refresh</v-icon>
          <span>Reload</span>
        </v-btn>
                      <!-- <v-btn icon>
            <v-icon @click="loadReports">refresh</v-icon>
          </v-btn> -->

      </v-card-title>
      <v-data-table
        v-if="reports"
        v-model="selected"
        :headers="headers"
        :items="reports"
        :search="search"
        item-key="id"
        class="elevation-1"
      >
        <template v-slot:item.action="{ item }">
          <v-btn icon>
            <v-icon small @click="selectReport(item, false)">visibility</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon small @click="selectReport(item, true)">save</v-icon>
          </v-btn>
        </template>
        <template slot="no-data"></template>
      </v-data-table>
      <v-overlay v-if="loadingDoc">
        <v-progress-circular v-if="loadingDoc" :size="70" :width="7" color="purple" indeterminate></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>
<script>
let rh = require('@/components/APIs/RequestHandler')
export default {
  data: () => ({
    reports: [],
    loadingDoc: false,
    selected: [],
    search: null,
    headers: [
      { text: 'Report Name', value: 'description', class: 'subtitle-1 font-weight-black' },
      { text: 'Date', value: 'preparedForDate', class: 'subtitle-1 font-weight-black' },
      { text: '', align: 'right', value: 'action', width: '10%' }
    ]
  }),
  created () {
    this.loadReports()
  },
  methods: {
    async selectReport (a, download) {
      this.loadingDoc = true
      this.selected = [a]
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_ITEMS}/document/${
        a.id
      }`

      var getResponse = await rh.default.getBlob(endpoint, true).catch(e => {
        this.errors.push(e)
        this.loadingDoc = false
      })
      if (getResponse && getResponse.data) {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(getResponse.data)
        if (download) {
          // Automatically Download
          link.setAttribute('download', 'Ignite-' + a.preparedForDate)
        } else {
          // These 2 lines are to automatically open in a new tab
          // link.setAttribute('open', a.name) // or any other extension
          // link.setAttribute('target', "_blank")
          link.setAttribute('open', 'Ignite-' + a.preparedForDate) // or any other extension
          link.setAttribute('target', '_blank')
        }
        document.body.appendChild(link)
        link.click()
        URL.revokeObjectURL(link.href)
      }
      this.loadingDoc = false
    },

    async loadReports () {
      if (!sessionStorage.getItem('loggedInUser')) {
        // console.log('User ID not set, unable to load reports')
        this.reports = []
        return
      }
      this.loadingDoc = true
      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_ITEMS
      }/document/user/${sessionStorage.getItem('loggedInUser')}`

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
        this.loadingDoc = false
      })
      if (!getResponse || !getResponse.data) {
        this.reports = []
      } else {
        this.reports = getResponse.data
      }
      this.loadingDoc = false
    }
  }
}
</script>
